import { AxiosResponse } from "axios";

import apiClient from "../../../../shared/infrastructure/api/client";

/**
 * The two session calls the EMDR board needs: read the session it runs for,
 * and start one from a dock.
 *
 * Its own small client rather than the session module's `SessionsAPI`: the
 * session module imports this one (its pages show the EMDR tab and panel), so
 * importing it back would close a module cycle. Kept to these two calls.
 */

/** What the board needs to know about the session it runs for. */
export type EmdrBoardSession = {
    id: string;
    title?: string;
    type?: string;
    patient_id?: string | null;
    couple_patient_id?: string | null;
    group_patient_id?: string | null;
};

/** A new in-person session, started from a dock to run the board in. */
export type EmdrSessionDraft = {
    title: string;
    date: string;
    hour: string;
    patient_id: string;
    therapist_id: string;
    therapy_type: string;
    type: "individual";
    ubication: "in person";
    duration: number;
    notes: string;
};

export const EmdrSessionsAPI = {
    get: (sessionId: string): Promise<AxiosResponse<EmdrBoardSession>> => apiClient.get(`/sessions/${sessionId}`),

    create: (draft: EmdrSessionDraft): Promise<AxiosResponse<EmdrBoardSession>> => apiClient.post("/sessions/", draft),
};
